
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/cu-building-the-future",
      function () {
        return require("private-next-pages/blog/cu-building-the-future/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/cu-building-the-future"])
      });
    }
  